import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/intro_crane.svg'


const _withScopeId = n => (_pushScopeId("data-v-1df98544"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "introduction", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy" }, [
  /*#__PURE__*/_createElementVNode("p", null, "NTTドコモ中国支社 主催にて"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("5Gオンライン平和学習を"),
    /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
    /*#__PURE__*/_createTextVNode("開催しました。")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "crane" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 広島・長崎の5Gエリアをつないで公募で集まった現地の学生様や"),
    /*#__PURE__*/_createElementVNode("br", { class: "sm-none" }),
    /*#__PURE__*/_createTextVNode("全国のweb参加者様と遠隔平和学習を行い、"),
    /*#__PURE__*/_createElementVNode("br", { class: "sm-show" }),
    /*#__PURE__*/_createTextVNode("その平和の想いを"),
    /*#__PURE__*/_createElementVNode("br", { class: "sm-none" }),
    /*#__PURE__*/_createTextVNode("VRアーティストのせきぐちあいみ氏の手ほどきを受けながら"),
    /*#__PURE__*/_createElementVNode("br", { class: "sm-none" }),
    /*#__PURE__*/_createTextVNode("共同制作にてデジタルアートで表現しました。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ・"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 5Gや最新のソリューションを通して、"),
    /*#__PURE__*/_createElementVNode("br", { class: "sm-none" }),
    /*#__PURE__*/_createTextVNode("平和への理解や感心を高めた本イベントを紹介します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 「ひろしまサンドボックス 5G LOVE&PEACE Lab.」の実証プロジェクトです。 ")
  ])
], -1))
const _hoisted_6 = { class: "button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("第1部"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("遠隔平和学習は"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("コチラ")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("第2部"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("高校生VRアート"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("作品はコチラ")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("せきぐちあいみ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("スペシャル"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("VR作品はコチラ")
], -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "button-circle blue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scroll('learn')))
      }, _hoisted_8),
      _createElementVNode("div", {
        class: "button-circle yellow",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scroll('vrart')))
      }, _hoisted_10),
      _createElementVNode("div", {
        class: "button-circle yellow",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scroll('special')))
      }, _hoisted_12)
    ])
  ]))
}